import React, { FunctionComponent, useEffect } from 'react';
import { ButtonBase, SxProps } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useFeatureFlagVariantKey, usePostHog } from 'posthog-js/react';
import {
  postHogWhatsAppSupportClicked,
  postHogWhatsAppSupportVisibilityShown,
} from '../../helper/PostHogHelper';
import {
  WHATSAPP_SUPPORT_FLAG,
  isWhatsAppSupportVisible,
} from '../../constants/featureFlags';

const buttonStyles: SxProps = {
  width: '48px',
  height: '48px',
  maxWidth: '48px',
  maxHeight: '48px',
  backgroundColor: '#128c7e',
  position: 'fixed',
  borderRadius: '50%',
  right: '20px',
  bottom: '20px',
  zIndex: 1000,
  boxShadow:
    '0 1px 6px 0 rgba(0, 0, 0, 0.06), 0 2px 32px 0 rgba(0, 0, 0, 0.16)',
};

const WhatsAppSupportButton: FunctionComponent = () => {
  const posthog = usePostHog();
  const variant = useFeatureFlagVariantKey(WHATSAPP_SUPPORT_FLAG);

  useEffect(() => {
    if (posthog && typeof variant === 'string') {
      postHogWhatsAppSupportVisibilityShown(posthog, {
        variant,
        surface: 'floating_button',
      });
    }
  }, [posthog, variant]);

  const handleClick = () => {
    if (posthog) {
      postHogWhatsAppSupportClicked(posthog, {
        location: 'floating_button',
        variant: typeof variant === 'string' ? variant : 'unknown',
      });
    }

    window.open(
      `${
        process.env.REACT_APP_WHATS_APP_SUPPORT_BASE_URL
      }?text=${encodeURIComponent('Hello')}`,
      '_blank'
    );
  };

  if (!isWhatsAppSupportVisible(variant)) {
    return null;
  }

  return (
    <ButtonBase sx={buttonStyles} onClick={handleClick}>
      <WhatsAppIcon sx={{ color: '#ffffff', width: '30px', height: '30px' }} />
    </ButtonBase>
  );
};

export default WhatsAppSupportButton;
